<template>
    <div>
        <Teleport to="[data-header-action]" v-if="isMounted">
            <div class="[ flex gap-3 ]">
                <ButtonComponent label="Create lesson plan" outlined @click="openCreateLessonPlanDialog">
                    <template #icon>
                        <JBIcon name="add-circle" />
                    </template>
                </ButtonComponent>
            </div>
        </Teleport>
        <DataTable :value="lessonPlans" scrollable scroll-height="flex" :loading="loading">
            <template #empty>
                <div class="[ flex flex-col gap-4 -mx-4 ]">
                    <Empty icon="unavailable" title="No lesson plans" message="Create a lesson plan to get started." />
                </div>
            </template>

            <Column field="Id" header="Id" />

            <Column field="Title" header="Title">
                <template #body="{ data }: { data: LessonPlan }">
                    <div class="[ flex items-center gap-3 ]">
                        <RouterLink :to="`/lessons/${data.Id}`" class="[ hover:underline ]">{{ data.Title }}</RouterLink>
                    </div>
                </template>
            </Column>
        </DataTable>
        <JBDialog header="Create New Lesson Plan" v-model:visible="showCreateLessonPlanDialog">
            <div>
                <InputText v-model="newLessonPlanTitle" />
            </div>
            <template #footer>
                <ButtonComponent :loading="creatingLessonPlan" label="Create" @click="createLessonPlan" />
            </template>
        </JBDialog>
    </div>
</template>

<script setup lang="ts">
import { Button as ButtonComponent, DataTable, Column, InputText } from "primevue";
import { onMounted, ref } from "vue";
import JBIcon from "@/components/JBIcon.vue";
import { LessonPlan, useApi2 } from "@/services/api2";
import { useMounted } from "@vueuse/core";
import Empty from "@/components/ui/Empty.vue";
import { useApiLoader } from "@/services/api";
import JBDialog from "@/components/ui/modals/JBDialog.vue";

definePage({
    meta: {
        title: "Lessons",
        icon: "file-upload",
    },
});

const isMounted = useMounted();

const showCreateLessonPlanDialog = ref(false);
const newLessonPlanTitle = ref('');

const { listLessonPlans, createLessonPlan: _createLessonPlan } = useApi2();

const { load, data: lessonPlans, loading } = useApiLoader(async () => {
    return await listLessonPlans();
}, []);

const { load: createLessonPlan, loading: creatingLessonPlan } = useApiLoader(async () => {
    await _createLessonPlan(newLessonPlanTitle.value);
    showCreateLessonPlanDialog.value = false;
    load();
}, null);

function openCreateLessonPlanDialog() {
    showCreateLessonPlanDialog.value = true;
}

onMounted(() => {
    load();
});

</script>